import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import useAuth from '../../hooks/useAuth';
import { PlatformProfilesProvider } from '../../context/PlatformProfilesContext';
import Loading from './Loading';

export default function PrivateShell() {
  const { user, loading } = useAuth();

  if (loading) {
    return <Loading />;
  }

  if (!user) {
    return <Navigate to="/auth/login" replace />;
  }

  return (
    <PlatformProfilesProvider>
      <Outlet />
    </PlatformProfilesProvider>
  );
}
